import { useState, useEffect } from 'react';

const STORAGE_KEY = 'gw_shopping_list';
const CHANGE_EVENT = 'gw-shopping-list-change';

const readList = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

const writeList = (items) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

const itemKey = (recipeId, index) => `${recipeId}::${index}`;

// localStorage-backed shopping list shared across the recipes page
export default function useShoppingList() {
  const [items, setItems] = useState(readList);

  useEffect(() => {
    const sync = () => setItems(readList());
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const toggleItem = (recipeId, recipeTitle, index, text) => {
    const key = itemKey(recipeId, index);
    const current = readList();
    const exists = current.some((i) => i.key === key);
    const next = exists
      ? current.filter((i) => i.key !== key)
      : [...current, { key, recipeId, recipeTitle, index, text, bought: false }];
    writeList(next);
  };

  const isInList = (recipeId, index) => items.some((i) => i.key === itemKey(recipeId, index));

  const toggleBought = (key) => {
    writeList(readList().map((i) => (i.key === key ? { ...i, bought: !i.bought } : i)));
  };

  const removeItem = (key) => writeList(readList().filter((i) => i.key !== key));

  const clearAll = () => writeList([]);

  return { items, toggleItem, isInList, toggleBought, removeItem, clearAll, count: items.length };
}
